'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _reactAddonsTransitionGroup = require('react-addons-transition-group');

var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactCustomScrollbars = require('react-custom-scrollbars');

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tag = function (_React$Component) {
  (0, _inherits3.default)(Tag, _React$Component);

  function Tag() {
    (0, _classCallCheck3.default)(this, Tag);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Tag.__proto__ || (0, _getPrototypeOf2.default)(Tag)).call(this));

    _this.willAnimate = _this.willAnimate.bind(_this);
    _this.didAnimate = _this.didAnimate.bind(_this);

    _this.state = {
      appear: true,
      appearActive: false
    };
    return _this;
  }

  (0, _createClass3.default)(Tag, [{
    key: 'componentWillAppear',
    value: function componentWillAppear(callback) {
      this.willAnimate(callback);
    }
  }, {
    key: 'componentDidAppear',
    value: function componentDidAppear() {
      this.didAnimate();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      this.willAnimate(callback);
    }
  }, {
    key: 'componentDidEnter',
    value: function componentDidEnter() {
      this.didAnimate();
    }
  }, {
    key: 'willAnimate',
    value: function willAnimate(callback) {
      var _this2 = this;

      var animationDelay = this.props.animationDelay;


      this.timerBefore = setTimeout(function () {
        return _this2.setState({
          appearActive: true
        });
      }, animationDelay);

      this.timer = setTimeout(callback, animationDelay + 500);
    }
  }, {
    key: 'didAnimate',
    value: function didAnimate() {
      this.setState({
        appear: false,
        appearActive: false
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.timerBefore) clearTimeout(this.timerBefore);
      if (this.timer) clearTimeout(this.timer);
    }
  }, {
    key: 'onTagImageLoaded',
    value: function onTagImageLoaded() {
      this.setState({
        tagImageLoaded: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames, _classnames2;

      var _props = this.props,
          onClick = _props.onClick,
          currentType = _props.currentType,
          t = _props.tag;
      var _state = this.state,
          tagImageLoaded = _state.tagImageLoaded,
          appear = _state.appear,
          appearActive = _state.appearActive;


      var styles = require('./SearchTags.scss');

      var isImgTag = !!t.image;

      var classes = (0, _classnames4.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.Tag, true), (0, _defineProperty3.default)(_classnames, styles['Tag--image'], isImgTag), (0, _defineProperty3.default)(_classnames, styles['Tag--text'], !isImgTag), (0, _defineProperty3.default)(_classnames, styles['Tag--image-imgNotLoaded'], isImgTag && !tagImageLoaded), (0, _defineProperty3.default)(_classnames, styles['Tag--image-imgLoaded'], isImgTag && tagImageLoaded), (0, _defineProperty3.default)(_classnames, styles['Tag--appear'], appear), (0, _defineProperty3.default)(_classnames, styles['Tag--appearActive'], appearActive), _classnames));

      var imgClasses = (0, _classnames4.default)((_classnames2 = {}, (0, _defineProperty3.default)(_classnames2, styles.Tag__img, isImgTag), (0, _defineProperty3.default)(_classnames2, styles['Tag__img--loaded'], isImgTag && tagImageLoaded), (0, _defineProperty3.default)(_classnames2, styles.Tag__text, !isImgTag), _classnames2));

      return _react2.default.createElement(
        'div',
        { className: classes, key: t.tag },
        isImgTag ? _react2.default.createElement(
          _reactRouter.Link,
          { className: styles.Tag__link, to: '/types/' + currentType + '?search=' + t.tag, onClick: onClick },
          _react2.default.createElement(
            'span',
            { className: styles.Tag__imgContainer },
            _react2.default.createElement('img', { className: imgClasses, src: t.image, onLoad: this.onTagImageLoaded.bind(this) })
          ),
          _react2.default.createElement(
            'span',
            { className: styles.Tag__label },
            t.tag
          )
        ) : _react2.default.createElement(
          _reactRouter.Link,
          { className: styles.Tag__link, to: '/types/' + currentType + '?search=' + t.tag, onClick: onClick },
          t.tag
        )
      );
    }
  }]);
  return Tag;
}(_react2.default.Component);

var SearchTags = function (_React$Component2) {
  (0, _inherits3.default)(SearchTags, _React$Component2);

  function SearchTags() {
    (0, _classCallCheck3.default)(this, SearchTags);
    return (0, _possibleConstructorReturn3.default)(this, (SearchTags.__proto__ || (0, _getPrototypeOf2.default)(SearchTags)).apply(this, arguments));
  }

  (0, _createClass3.default)(SearchTags, [{
    key: 'onSearchTagClicked',
    value: function onSearchTagClicked(ev, t) {
      ev.preventDefault();

      var onTagClick = this.props.onTagClick;


      onTagClick(t);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          currentType = _props2.currentType,
          tags = _props2.tags;


      var styles = require('./SearchTags.scss');

      var imageTags = tags.filter(function (t) {
        return !!t.image;
      });
      var textTags = tags.filter(function (t) {
        return !t.image;
      });

      var onSearchTagClicked = function onSearchTagClicked(t) {
        return function (ev) {
          return _this4.onSearchTagClicked(ev, t);
        };
      };

      var headingTransitionName = {
        appear: styles['SearchTagsContainer__heading--appear'],
        appearActive: styles['SearchTagsContainer__heading--appear-active']
      };

      var renderThumbVertical = function renderThumbVertical() {
        return _react2.default.createElement('div', { style: {
            background: '#000',
            borderRadius: '4px',
            width: '8px',
            display: 'block',
            border: '1px solid #c6c6c6'
          } });
      };

      return _react2.default.createElement(
        _reactCustomScrollbars.Scrollbars,
        { universal: true, autoHide: true, autoHeight: true, renderThumbVertical: renderThumbVertical, style: { top: 0, bottom: 0 } },
        _react2.default.createElement(
          'div',
          { className: styles.SearchTagsContainer },
          _react2.default.createElement(
            _reactAddonsCssTransitionGroup2.default,
            { transitionName: headingTransitionName, transitionLeave: false, transitionEnter: false, transitionAppear: true, transitionAppearTimeout: 500 },
            imageTags.length ? _react2.default.createElement(
              'h1',
              { className: styles.SearchTagsContainer__heading },
              'Begin typing to get suggestions...'
            ) : null
          ),
          imageTags.length ? _react2.default.createElement(
            'div',
            { className: styles.SearchTags + ' ' + styles['SearchTags--image'] },
            _react2.default.createElement(
              _reactAddonsTransitionGroup2.default,
              null,
              imageTags.map(function (t, i) {
                return _react2.default.createElement(Tag, { animationDelay: i * 10, currentType: currentType, tag: t, key: t.tag, onClick: onSearchTagClicked(t.tag) });
              })
            )
          ) : null,
          textTags.length ? _react2.default.createElement(
            'div',
            { className: styles.SearchTags + ' ' + styles['SearchTags--text'] },
            _react2.default.createElement(
              _reactAddonsTransitionGroup2.default,
              null,
              textTags.map(function (t, i) {
                return _react2.default.createElement(Tag, { animationDelay: i * 10, currentType: currentType, tag: t, key: t.tag, onClick: onSearchTagClicked(t.tag) });
              })
            )
          ) : null
        )
      );
    }
  }]);
  return SearchTags;
}(_react2.default.Component);

exports.default = SearchTags;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchTags/SearchTags.jsx
// module id = 2656
// module chunks = 0